import React from 'react';

import * as S from './styled';

type Props = {
  size?: string,
  isBlink?: boolean,
  disabled?: boolean,
};

const Checkbox = ({
  size,
  isBlink,
  disabled,
  ...rest
}: Props) => (
  <S.Checkbox
    size={size}
    isBlink={isBlink}
    disabled={disabled}
  >
    <S.Input
      {...rest}
      size={size}
      type="checkbox"
      disabled={disabled}
    />
    <span />
  </S.Checkbox>
);

Checkbox.defaultProps = {
  size: '',
  isBlink: false,
  disabled: false,
};

export default Checkbox;
